import React from 'react';
import { CreditCard } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const invoices = [
  { date: 'Sep 26, 2024', description: 'AlphaNQ Premium', amount: '$99.00' },
  { date: 'Aug 26, 2024', description: 'AlphaNQ Premium', amount: '$99.00' },
  { date: 'Jul 26, 2024', description: 'AlphaNQ Premium', amount: '$99.00' },
];

const BillingModal = () => {
  const app = useAppContext();

  return (
    <Modal isOpen={app.showBillingModal} onClose={() => app.setShowBillingModal(false)} size="lg">
      <div className="billing-modal__header">
        <div className="billing-modal__icon">
          <CreditCard size={26} />
        </div>
        <h2 className="billing-modal__title">Manage Billing</h2>
      </div>

      <div className="billing-modal__content">
        <div className="account-section">
          <div className="account-section__top">
            <span className="account-section__title">Payment Method</span>
            <button
              className="account-section__action"
              onClick={() => app.setShowUpdatePaymentModal(true)}
            >
              Update
            </button>
          </div>
          <div className="payment-card">
            <div className="payment-card__brand">
              <svg width="26" height="16" viewBox="0 0 28 18" fill="none">
                <rect width="28" height="18" rx="2" fill="#252A37" />
                <path d="M9.5 11.5H18.5V6.5H9.5V11.5Z" fill="#FF5F00" />
                <path d="M10 9C10 7.4 10.8 5.9 12 5C11 4.2 9.8 3.8 8.5 3.8C5.5 3.8 3 6.1 3 9C3 11.9 5.5 14.2 8.5 14.2C9.8 14.2 11 13.8 12 13C10.8 12 10 10.6 10 9Z" fill="#EB001B" />
                <path d="M25 9C25 11.9 22.5 14.2 19.5 14.2C18.2 14.2 17 13.8 16 13C17.2 12.1 18 10.6 18 9C18 7.4 17.2 5.9 16 5C17 4.2 18.2 3.8 19.5 3.8C22.5 3.8 25 6.2 25 9Z" fill="#F79E1B" />
              </svg>
            </div>
            <div className="payment-card__info">
              <div className="payment-card__number">Mastercard ending in 4532</div>
              <div className="payment-card__expiry">Expires 05/2026</div>
            </div>
            <div className="payment-card__badge">Default</div>
          </div>
        </div>

        <div className="account-section">
          <div className="account-section__title">Billing History</div>
          <div className="billing-table__wrapper">
            <table className="billing-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th className="billing-table__right">Amount</th>
                  <th>Invoice</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv, i) => (
                  <tr key={i}>
                    <td>{inv.date}</td>
                    <td>{inv.description}</td>
                    <td className="billing-table__right">{inv.amount}</td>
                    <td>
                      <button className="billing-table__link">Download</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="modal__footer">
        <button
          className="btn btn-danger-ghost"
          onClick={() => {
            app.setShowBillingModal(false);
            app.setShowCancelConfirmModal(true);
          }}
        >
          Cancel Subscription
        </button>
      </div>
    </Modal>
  );
};

export default BillingModal;
